/**
 * phase-tree-lock-open-shackle — the shared lock-state VOCABULARY.
 *
 * Kept out of `LockStateIcon.tsx` so that file exports only its component
 * (react-refresh), and so the tree and the placement card draw their state
 * names from exactly one place — the recurring defect this phase closes is
 * forked copies of one rule.
 */

/** Accessible name for a lock state. Same words on the tree and the card. */
export function lockStateLabel(locked: boolean): string {
  return locked ? 'Placement locked' : 'Placement unlocked';
}

/** Tooltip: names the state AND points at where it is changed (the placement card).
 *  phase-workspace-naming-and-preview-cluster — the pane is titled Workspace
 *  now; user-facing text calls it that, never the old centre-pane wording. */
export function lockStateTitle(locked: boolean): string {
  return locked
    ? 'Placement locked — change it on the Placement card in the Workspace'
    : 'Placement unlocked — change it on the Placement card in the Workspace';
}
